<template>
  <div class="search-form">
    <div class="pr-2" style="max-width: 580px;">
      <b-form @reset="reset" onsubmit="return false">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            :placeholder="
              $l('table_search_placeholder') || '任务标题/客户/经办人/报告人/项目名称/会议名称  搜索...'
            "
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
          <slot />
        </b-input-group>
      </b-form>
    </div>
    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      :size="600"
      :show-close="false"
      :wrapper-closable="false"
      :close-on-press-escape="false"
      @close="closeAdvqueryDialog()"
    >
      <template #title>
        <span role="heading">
          {{ $l('INDEX.advanced_search') || '高级搜索' }}
        </span>
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </template>
      <div class="drawer-main">
        <el-form ref="form" :model="form" size="small" label-position="top">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$l('table_label_tskInfoNo') || '任务编号'">
                <el-input
                  v-model="form.tskInfoNo"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('table_label_tskOverview') || '任务概述'"
              >
                <el-input
                  v-model="form.tskOverview"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                size="small"
                :label="$l('INDEX.label_customer') || '客户'"
              >
                <dict-select
                  v-model="form.listCustCode"
                  url="/master/common/dict/customerSelectByStatus"
                  :body="{ dictType: ['W', 'P', 'B', 'Y'] }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  clearable
                  multiple
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_expoInfoName') || '项目名称'"
              >
                <el-input
                  v-model="form.expoInfoName"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purposeOrIssue') || '会议名称'"
              >
                <el-input
                  v-model="form.purposeOrIssue"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_createBy') || '报告人'">
                <dict-select
                  v-model="form.listCreateBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  clearable
                  multiple
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_tskBy') || '经办人'">
                <dict-select
                  v-model="form.listTskBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  clearable
                  multiple
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_tskType') || '任务类型'">
                <dict-select
                  v-model="form.listTskType"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'tskType' }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  clearable
                  multiple
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_listTskImportantLevel') || '重要级别'"
              >
                <dict-select
                  v-model="form.listTskImportantLevel"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'tskImportantLevel' }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  clearable
                  multiple
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_tskEndDate') || '到期日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.tskEndDateStart"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.tskEndDateEnd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_modifyDate') || '更新日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateStart"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateEnd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_createDate') || '创建时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateStart"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col class="text-center" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateEnd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      value-format="yyyy-MM-dd"
                      type="date"
                      style="width: 100%"
                    />
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
const initForm = { keyword: '' }
export default {
  components: {},
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 20px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
